export const OPERATIONAL_COST_CATEGORIES = [
    { value: 'aluguel', label: 'Aluguel' },
    { value: 'agua', label: 'Água' },
    { value: 'luz', label: 'Luz (Exceto consumo das impressoras)' },
    { value: 'internet', label: 'Internet / Telefone' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'assinaturas', label: 'Assinaturas' },
    { value: 'modelos', label: 'Compra de modelos' },
    { value: 'terceiros', label: 'Serviços de terceiros (manutenções, limpeza, etc)' },
    { value: 'funcionarios', label: 'Funcionários' },
    { value: 'outros', label: 'Outros' },
];

export const OPERATIONAL_COST_RECURRING = 'recurring';
export const OPERATIONAL_COST_ONE_TIME = 'one_time';

export const OPERATIONAL_COST_FREQUENCIES = [
    { value: 'monthly', label: 'Mensal', months: 1 },
    { value: 'quarterly', label: 'Trimestral', months: 3 },
    { value: 'semiannual', label: 'Semestral', months: 6 },
    { value: 'annual', label: 'Anual', months: 12 },
];

export function operationalCostCategoryLabel(value) {
    const found = OPERATIONAL_COST_CATEGORIES.find((item) => item.value === value);
    return found?.label || value || '—';
}

export function operationalCostFrequencyLabel(value) {
    const found = OPERATIONAL_COST_FREQUENCIES.find((item) => item.value === value);
    return found?.label || 'Mensal';
}

export function operationalCostFrequencyMonths(value) {
    const found = OPERATIONAL_COST_FREQUENCIES.find((item) => item.value === value);
    return found?.months || 1;
}

export function operationalCostMonthlyCents(amountCents, frequency) {
    const amount = Number(amountCents) || 0;
    const months = operationalCostFrequencyMonths(frequency);
    if (months <= 1) {
        return amount;
    }
    return Math.trunc(amount / months);
}

export function isRecurringOperationalCost(recurrence) {
    return String(recurrence || OPERATIONAL_COST_RECURRING) === OPERATIONAL_COST_RECURRING;
}

export function isArchivedOperationalCost(item) {
    return Boolean(item?.archived_at);
}

export function operationalCostQuotaKey(recurrence) {
    return recurrence === OPERATIONAL_COST_ONE_TIME
        ? 'operational_costs_one_time'
        : 'operational_costs_recurring';
}
